<template>
    <button
        class="copy-btn"
        :class="{ copied: copied }"
        :title="titleString"
        @click="handleCopyClick"
    >
        <span
            v-show="!copied"
            v-text="$ml.get('copyCode')"
        />
        <span
            v-show="copied"
            v-text="$ml.get('copied')"
        />

        <img class="copy-icon" src="@/assets/img/icons/copy--blue.svg" alt="" tabindex="-1" />
        <img class="copy-icon copy-icon--hover" src="@/assets/img/icons/copy--white.svg" alt="" tabindex="-1" />
    </button>
</template>

<script>
    export default {
        data() {
            return {
                copied: false,
            };
        },
        props: {
            titleString: {
                type: String,
                default: '',
            },
        },
        methods: {
            handleCopyClick() {
              this.$emit('click-copy');
              this.copied = true;
              setTimeout(() => {
                  this.copied = false;
              }, 3000);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .copy-btn {
        background-color: transparent;
        color: #0774E7;
        font-size: 20px;
        font-weight: 600;
        border: 1px solid #0774E7;
        border-radius: 8px;
        padding: 8px 16px;
        transition: all ease 0.3s;
        min-width: 208px;

        span {
            margin-right: 8px;
        }

        .copy-icon {
            opacity: 1;
            position: relative;
            height: auto;
            transition: all ease 0.3s;

            &--hover {
                opacity: 0;
                position: absolute;
                height: 0;
            }
        }

        &:hover,
        &.copied {
            background-color: #0774E7;
            color: white;

            .copy-icon {
                opacity: 0;
                position: absolute;
                height: 0;

                &--hover {
                  opacity: 1;
                  position: relative;
                  height: auto;
                }
            }
        }
    }
</style>